import { CoreModel } from '../core/core.model';
import { JsonEditorRowButtonModel } from '../json-editor/json-editor-row-button.model';
export class JsonEditorModel extends CoreModel {
/**
 * JSON input to be converted into tree
 */
data?: any;
/**
 * Whether to prevent keys from being edited. Default: true.
 */
lockKeys?: boolean;
/**
 * Array of buttons to be rendered per level
 */
rowButtons?: [ JsonEditorRowButtonModel[] ];
/**
 * Circumstances to show buttons in. Can be: hover, select or always.
 */
showButtons?: string;
/**
 * @hidden
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function JsonEditorModel_tsickle_Closure_declarations() {
/**
 * JSON input to be converted into tree
 * @type {?}
 */
JsonEditorModel.prototype.data;
/**
 * Whether to prevent keys from being edited. Default: true.
 * @type {?}
 */
JsonEditorModel.prototype.lockKeys;
/**
 * Array of buttons to be rendered per level
 * @type {?}
 */
JsonEditorModel.prototype.rowButtons;
/**
 * Circumstances to show buttons in. Can be: hover, select or always.
 * @type {?}
 */
JsonEditorModel.prototype.showButtons;
}

